export default {
  nav: { models: "Modelle", gallery: "Galerie", fleet: "Flotten & B2B", contact: "Kontakt" },
  cta: { testDrive: "Probefahrt buchen" },
  hero: {
    overline: "Offizieller Generalimporteur Schweiz",
    title: "Elektrisch in die Zukunft. Jetzt in der Schweiz.",
    subtitle: "Skyworth Elektrofahrzeuge verbinden grosse Reichweite, modernste Technik und ehrliche Schweizer Betreuung – von der Probefahrt bis zum Service.",
    btnModels: "Modelle entdecken",
  },
  stats: [
    { value: "30'000+", label: "Mitarbeitende weltweit im Skyworth-Konzern" },
    { value: "7 Jahre", label: "Herstellergarantie auf den BE11" },
    { value: "489 km", label: "WLTP-Reichweite (BE11 Long Range)" },
    { value: "100 %", label: "Betreuung direkt aus der Schweiz" },
  ],
  showcase: {
    overline: "Modelle",
    title: "Ein Modell für jeden Anspruch.",
    allLink: "Alle Modelle im Detail",
    discover: "Entdecken",
  },
  brand: {
    overline: "Die Marke",
    title: "Vom Elektronikkonzern zum E-Mobilitätspionier.",
    text: "Skyworth ist ein globaler Technologiekonzern mit über 30'000 Mitarbeitenden – von Unterhaltungselektronik bis zu intelligenten Energielösungen. Mit Skywell bringt die Marke dieses Know-how auf die Strasse: robust gebaute Elektrofahrzeuge mit grosszügiger Ausstattung und starken Garantien.",
    bullets: [
      "Gegründet im Jahr 2000 – über zwei Jahrzehnte Erfahrung",
      "Fahrzeuge in Europa, Asien und Australien im Einsatz",
      "Auto + Home: Vom Fahrzeug bis zur Energielösung fürs Zuhause",
    ],
  },
  videoSection: {
    overline: "Film",
    title: "Skyworth in Bewegung.",
    text: "Erleben Sie Design, Technik und Fahrgefühl der Skyworth-Modellreihe im offiziellen Markenfilm.",
  },
  fleetHome: {
    overline: "Flotten & B2B",
    title: "Elektromobilität für Ihr Unternehmen.",
    text: "Ob einzelner Geschäftswagen oder ganze Flotte: Wir beraten Sie persönlich zu Fahrzeugwahl, Ladeinfrastruktur und Betrieb – mit direktem Draht zum Hersteller und Service aus der Schweiz.",
    button: "Flotten-Anfrage stellen",
  },
  service: {
    overline: "Service & Vertrauen",
    title: "Ihr Ansprechpartner in der Schweiz.",
    cards: [
      { title: "Offizieller Generalimporteur", text: "Direkter Herstellerzugang – ohne Umwege, mit allen Vorteilen für Sie." },
      { title: "Showroom & Service in der Schweiz", text: "Persönliche Beratung, Probefahrten und Wartung direkt vor Ort." },
      { title: "Garantie & Ersatzteile vor Ort", text: "7 Jahre Herstellergarantie und schweizerische Ersatzteilversorgung." },
    ],
  },
  ctaSection: {
    title: "Überzeugen Sie sich selbst – bei einer Probefahrt.",
    text: "Erleben Sie Reichweite, Ruhe und Fahrspass live. Wir melden uns innert 24 Stunden mit einem Terminvorschlag.",
    btnPrimary: "Jetzt Probefahrt buchen",
  },
  footer: {
    tagline: "Offizieller Generalimporteur für Skyworth & Skywell Elektrofahrzeuge in der Schweiz. Showroom, Service, Garantie und Ersatzteile – alles vor Ort.",
    navTitle: "Navigation",
    contactTitle: "Kontakt",
    rights: "SkyworthCars Schweiz. Alle Rechte vorbehalten.",
    legal: "Impressum & Datenschutz folgen.",
    youtube: "Skyworth Auto auf YouTube",
  },
  galleryPage: {
    overline: "Galerie",
    title: "Grosse Bilder. Alle Modelle.",
    subtitle: "Offizielle Fahrzeugbilder und Videos – wählen Sie ein Modell und stöbern Sie durch die Galerie.",
    explore: "Modell entdecken",
    videoTitle: "Video",
  },
  modelsPage: {
    overline: "Modellpalette",
    title: "Alle Skyworth Modelle für die Schweiz.",
    subtitle: "Vom effizienten Elektro-SUV bis zum Luxus-Flaggschiff – entdecken Sie die Modellreihe mit Bildern, technischen Daten und Ausstattung.",
    loading: "Modelle werden geladen …",
  },
  detail: {
    back: "Alle Modelle",
    testDrive: "Probefahrt buchen",
    consult: "Beratung anfragen",
    about: "Über dieses Modell",
    specs: "Technische Daten",
    disclaimer: "Alle Angaben ohne Gewähr. Änderungen und Irrtümer vorbehalten.",
    photos: "Fotos & Impressionen",
    videoSoon: "Video-Bereich: Offizielle Modellvideos folgen in Kürze.",
    ctaTitle: "{{name}} live erleben?",
    ctaBtn: "Probefahrt vereinbaren",
    notFound: "Modell nicht gefunden",
    notFoundBack: "Zur Modellübersicht",
    loading: "Wird geladen …",
  },
  testDrivePage: {
    overline: "Probefahrt",
    title: "Buchen Sie Ihre Probefahrt.",
    subtitle: "Wählen Sie Ihr Wunschmodell und Ihren Wunschtermin – wir melden uns innert 24 Stunden mit einer Bestätigung.",
  },
  contactPage: {
    overline: "Kontakt",
    title: "Wir sind für Sie da.",
    subtitle: "Fragen zu einem Modell, zur Verfügbarkeit oder zum Service? Schreiben Sie uns oder rufen Sie direkt an.",
    directTitle: "Direktkontakt",
    showroomTitle: "Showroom & Service",
    hours: "Öffnungszeiten auf Anfrage",
  },
  fleetPage: {
    overline: "Flotten & B2B",
    title: "Ihre Flotte. Elektrisch. Schweizer betreut.",
    subtitle: "Senken Sie Betriebskosten und Emissionen – mit Skyworth Elektrofahrzeugen, persönlicher Beratung und zuverlässigem Service direkt aus der Schweiz.",
    scrollBtn: "Anfrage stellen",
    cards: [
      { title: "Flottenlösungen", text: "Vom einzelnen Geschäftswagen bis zur ganzen Flotte – massgeschneiderte Angebote für Schweizer Unternehmen." },
      { title: "Ladeinfrastruktur", text: "Beratung zu Ladelösungen am Firmenstandort und Vehicle-to-Load für den mobilen Einsatz." },
      { title: "Service-Partnerschaft", text: "Direkter Draht zum Generalimporteur: Garantieabwicklung, Ersatzteile und Wartung aus einer Hand." },
    ],
    vans: {
      overline: "Nutzfahrzeuge",
      title: "Auch für Ihre Logistik: der Skyworth HONGTU Cargo Van.",
      text: "Elektrische Transporter und Nutzfahrzeuge für den urbanen Lieferverkehr – auf Anfrage für Ihre Flotte verfügbar.",
      button: "Technische Daten & Details zum HONGTU V9",
      cargoLabel: "HONGTU Cargo Van · Güterverkehr",
      passengerLabel: "HONGTU Passenger Van · Personenbeförderung",
    },
    formSection: { overline: "Flotten-Anfrage", title: "Erzählen Sie uns von Ihrem Bedarf." },
    personal: "Lieber persönlich?",
    personalLink: "Probefahrt für Ihr Team vereinbaren",
  },
  form: {
    name: "Name",
    email: "E-Mail",
    phone: "Telefon",
    company: "Firma",
    model: "Modell",
    modelPlaceholder: "Modell wählen (optional)",
    consultation: "Beratung gewünscht",
    date: "Wunschdatum",
    message: "Nachricht",
    messagePlaceholder: "Ihre Nachricht an uns …",
    namePlaceholder: "Vor- und Nachname",
    privacy: "Mit dem Absenden stimmen Sie zu, dass wir Sie zu Ihrer Anfrage kontaktieren dürfen.",
    submitProbefahrt: "Probefahrt anfragen",
    submitKontakt: "Nachricht senden",
    submitFlotte: "Flotten-Anfrage senden",
    sending: "Wird gesendet …",
    successProbefahrt: "Vielen Dank! Wir melden uns innert 24 Stunden für Ihre Probefahrt.",
    successKontakt: "Vielen Dank für Ihre Anfrage! Wir melden uns schnellstmöglich.",
  },
  status: {
    available: "Verfügbar",
    orderable: "Bestellbar",
    soon: "Bald verfügbar",
    onRequest: "Auf Anfrage",
  },
  priceOnRequest: "Preis auf Anfrage",
  models: {
    be11: {
      category: "Elektro-SUV",
      tagline: "Der vollelektrische SUV – elektrisch fahren, ganz einfach.",
      description: "Der Skywell BE11 macht den Umstieg aufs Elektrofahren mühelos: grosse Reichweite, schnelles Laden und über 30 intelligente Assistenzsysteme. Dazu ein grosszügiger, hochwertiger Innenraum und eine Ausstattung, die keine Wünsche offen lässt – von der 360°-Kamera bis zum Panorama-Schiebedach.",
      features: [
        "12.8\" Touchscreen + 12.3\" digitales Fahrerdisplay",
        "Apple CarPlay & Android Auto (kabellos)",
        "360°-Rundumsicht-Kamera & Parkassistent",
        "Über 30 Fahrerassistenzsysteme (ADAS): u. a. ACC, AEB, LKA, RCTA",
        "Panorama-Schiebedach (öffenbar)",
        "Beheizte & belüftete Vordersitze, Memory-Funktion",
        "Kabelloses Smartphone-Laden, 230-V-Steckdose (V2L)",
        "Elektrische Heckklappe mit Sensoröffnung",
      ],
      specs: [
        ["Batterie", "72 kWh / 86 kWh"],
        ["Reichweite (WLTP)", "bis 489 km"],
        ["Leistung", "150 kW (204 PS) / 320 Nm"],
        ["DC-Schnellladen", "bis 80 kW (10–80 % in ca. 36–45 Min.)"],
        ["AC-Laden", "11 kW"],
        ["Antrieb", "Frontantrieb"],
        ["Länge × Breite × Höhe", "4'720 × 1'908 × 1'696 mm"],
        ["Radstand", "2'800 mm"],
        ["Gepäckraum", "689–1'608 Liter"],
        ["Vehicle-to-Load (V2L)", "Ja – 230-V-Steckdose an Bord"],
        ["Infotainment", "12.8\" Touchscreen + 12.3\" Fahrerdisplay"],
        ["Soundsystem", "Metz® mit 8 Lautsprechern & Subwoofer"],
        ["Garantie", "7 Jahre Herstellergarantie"],
      ],
    },
    "ht-i": {
      category: "Plug-in-Hybrid SUV",
      tagline: "Elektrisch im Alltag, sorgenfrei auf langen Strecken.",
      description: "Der Skyworth HT-i kombiniert einen effizienten 1.5-Liter-Motor mit einem leistungsstarken Elektroantrieb. Im Alltag fahren Sie rein elektrisch – auf Reisen sorgt der Hybridantrieb für eine Gesamtreichweite von bis zu 1'267 km. Das ideale Fahrzeug für alle, die Flexibilität ohne Ladeplanung suchen.",
      features: [
        "Rein elektrisches Fahren im Alltag",
        "Keine Ladeplanung auf Langstrecken nötig",
        "Grosszügiger SUV-Innenraum",
        "Modernes Infotainment & Assistenzsysteme",
      ],
      specs: [
        ["Antrieb", "Plug-in-Hybrid (1.5 l + Elektromotor)"],
        ["Gesamtreichweite", "bis 1'267 km (Herstellerangabe)"],
        ["Rein elektrische Reichweite", "bis ca. 200 km (Herstellerangabe)"],
        ["Karosserie", "5-türiger SUV, 5 Sitze"],
        ["Garantie", "Herstellergarantie – Details auf Anfrage"],
      ],
    },
    ce11: {
      category: "Elektro-Luxus-SUV",
      tagline: "Luxus und Würde – das Flaggschiff der Skyworth-Modellreihe.",
      description: "Der Skyworth CE11 definiert elektrischen Luxus neu: ein grosszügiger Panorama-Innenraum, ein verdeckter gebogener Deckenbildschirm und 21 Lautsprecher schaffen ein immersives Erlebnis. Mit Smart AI (Swaiot GPT) wird das Fahrzeug zum intelligenten Begleiter.",
      features: [
        "Grosszügiger Panorama-Innenraum",
        "Verdeckter gebogener Deckenbildschirm",
        "21 Lautsprecher für ein immersives Klangerlebnis",
        "Smart AI · Swaiot GPT Sprachassistent",
        "Luxuriöse Materialien und Verarbeitung",
      ],
      specs: [
        ["Antrieb", "Vollelektrisch"],
        ["Karosserie", "Luxus-SUV"],
        ["Soundsystem", "21 Lautsprecher"],
        ["Weitere technische Daten", "folgen in Kürze"],
      ],
    },
    ev6: {
      category: "Elektro-SUV",
      tagline: "Der bewährte Elektro-SUV der ersten Skyworth-Generation.",
      description: "Der Skyworth EV6 ist der bewährte Elektro-SUV, mit dem die Marke den internationalen Markt erobert hat. Bewährte Technik, grosszügiger Innenraum mit Panorama-Schiebedach und das SKYLINK-Vernetzungssystem machen ihn zur soliden Wahl für den Einstieg in die Elektromobilität.",
      features: [
        "SKYLINK Intelligent Networking – Auto & Zuhause vernetzt",
        "Panorama-Schiebedach",
        "L2.5-Fahrassistenz mit über 15 Funktionen",
        "Immersives Audio- & Video-System",
        "Grosszügiger Innenraum mit flexiblen Sitzmodi",
      ],
      specs: [
        ["Antrieb", "Vollelektrisch"],
        ["Batterie", "60.2 kWh"],
        ["Reichweite", "bis 434 km (NEDC)"],
        ["Beschleunigung 0–100 km/h", "6.7 s"],
        ["DC-Schnellladen", "20–70 % in ≤ 32 Min."],
        ["Karosserie", "5-türiger SUV, 5 Sitze"],
        ["Garantie", "Herstellergarantie – Details auf Anfrage"],
      ],
    },
    hongtu: {
      category: "Elektro-Transporter",
      tagline: "100 % elektrischer Cargo Van für professionelle Logistik.",
      description: "Der Skyworth HONGTU V9 ist der vollelektrische Transporter für urbane Logistik und Last-Mile-Zustellung: bis zu 14 m³ Ladevolumen, über 1'400 kg Nutzlast und bis zu 408 km Reichweite. Dank 120-kW-DC-Schnellladen ist er in rund 36 Minuten wieder einsatzbereit – null Emissionen, null Kompromisse.",
      features: [
        "Zwei Aufbauvarianten: L2H2 und L3H4",
        "Ladeflächenbreite 1'403 mm zwischen den Radkästen",
        "Aerodynamisches Design (cw 0.29) für hohe Effizienz",
        "DC-Schnellladen für minimale Standzeiten",
        "Ideal für urbane Logistik, Handwerk und Last Mile",
        "Auch als Passenger Van (Personenversion) erhältlich",
      ],
      specs: [
        ["Antrieb", "Vollelektrisch, 150 kW (204 PS) / 370 Nm"],
        ["Batterie", "bis 100.9 kWh (CATL)"],
        ["Reichweite (WLTP)", "bis 408 km"],
        ["DC-Schnellladen", "bis 120 kW (20–80 % in ca. 36 Min.)"],
        ["Ladevolumen", "9 m³ (L2H2) / 14 m³ (L3H4)"],
        ["Nutzlast", "bis 1'464 kg"],
        ["Zulässiges Gesamtgewicht", "4'250 kg"],
        ["Länge × Breite × Höhe", "5'490–5'990 × 1'990 × 2'200–2'700 mm"],
        ["Luftwiderstandsbeiwert", "cw 0.29"],
        ["Garantie", "Herstellergarantie – Details auf Anfrage"],
      ],
    },
    "hongtu-passenger": {
      category: "Elektro-Personenbus",
      tagline: "Raum. Komfort. Effizienz – der elektrische Shuttle-Van.",
      description: "Der Skyworth HONGTU Passenger Van bringt bis zu 17 Personen leise und emissionsfrei ans Ziel – ideal für Hotel-Shuttles, Flughafentransfers und Firmen. Mit 2'025 mm Stehhöhe, komfortablen Einzelsitzen (optional mit Massagefunktion) und moderner Assistenztechnik reist Ihre Gruppe entspannt. Die grosse Batterie und das 120-kW-Schnellladen halten die Standzeiten minimal.",
      features: [
        "Bis zu 17 Sitzplätze für Shuttle- und Gruppenverkehr",
        "Komfortable Einzelsitze, optional mit Massagefunktion",
        "Stehhöhe von 2'025 mm – bequemes Ein- und Aussteigen",
        "Leiser, emissionsfreier Antrieb für Hotel- & City-Shuttles",
        "Modulare Plattform: auch als Cargo Van erhältlich",
      ],
      specs: [
        ["Antrieb", "Vollelektrisch, bis 150 kW (204 PS), Hinterradantrieb"],
        ["Batterie", "bis 100.9 kWh (CATL)"],
        ["Reichweite (WLTP)", "bis ca. 408 km"],
        ["DC-Schnellladen", "bis 120 kW (20–80 % in ca. 36 Min.)"],
        ["Sitzplätze", "bis zu 17 (je nach Konfiguration)"],
        ["Innenhöhe", "2'025 mm Stehhöhe"],
        ["Infotainment", "12.8\" Zentraldisplay"],
        ["Assistenzsysteme", "L2+ Fahrerassistenz (ADAS)"],
        ["Garantie", "Herstellergarantie – Details auf Anfrage"],
      ],
    },
  },
};
